

  const carousel = document.getElementById('carousel');
  const dots = document.querySelectorAll('.dot');

  function updateDots(activeIndex) {
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === activeIndex);
    });
  }

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.getAttribute('data-index'));
      const scrollAmount = index * (212 + 16); // column width + gap
      carousel.scrollTo({ left: scrollAmount, behavior: 'smooth' });
      updateDots(index);
    });
  });

  carousel.addEventListener('scroll', () => {
    const scrollLeft = carousel.scrollLeft;
    const index = Math.round(scrollLeft / 228); // column width + gap
    updateDots(index);
  });


  